<style lang="postcss">
	.templates-nav {
		display: flex;
		flex-flow: column;
		width: 100%;
	}
	.templates-menu {
		display: flex;
		flex-flow: row;
		align-items: flex-start;
		gap: 0.35rem;
		flex-wrap: nowrap;
	}
	.templates-menu > li,
	.templates-menu--sub > li {
		white-space: nowrap;
		display: inline-flex;
		flex-flow: row;
		flex-wrap: nowrap;
		align-items: center;
		background: rgba(0, 0, 0, 0.1);
		border-radius: 4px;
		font-size: 0.865rem;
		scroll-margin: 3rem;
	}
	.templates-menu > li.active,
	.templates-menu--sub > li.active {
		background: rgb(31, 41, 55);
		color: white;
	}
	.templates-menu > li a,
	.templates-menu--sub > li a {
		white-space: nowrap;
		display: inline-flex;
		flex-flow: row;
		flex-wrap: nowrap;
		align-items: center;
		padding: 0.35rem 0.65rem;
		gap: 0.5rem;
		width: fit-content;
	}
	.templates-menu .category-icon {
		display: inline-flex;
		width: 1rem;
		height: 1rem;
	}
	.templates-menu--sub {
		display: flex;
		flex-flow: row;
		align-items: flex-start;
		gap: 0.35rem;
		flex-wrap: nowrap;
	}
	.templates-menu--sub li {
	}
	.templates-count {
		display: none;
		font-size: 12px;
		border-radius: 2px;
		padding: 1px;
	}
	.form-templates-h1 {
		font-size: 2.85rem;
		padding: 0 1rem;
		font-weight: 700;
		line-height: 1;
		letter-spacing: -0.5px;
		line-height: 1.15;
		color: rgb(46, 57, 72);
		position: relative;
		text-align: center;
		margin-bottom: 0rem;
		margin-top: 0rem;
	}
	.form-templates-h1.small {
		margin-top: 0rem;
		font-size: 2.5rem;
		font-weight: 600;
	}
	.form-templates-description {
		font-size: 1rem;
	}
	.form-templates-description.large {
		font-size: 1.125rem;
	}
	.h1-highlight {
		font-weight: 860;
		background-color: currentColor;
		background-size: 100%;
		background-clip: text;
		-webkit-text-fill-color: transparent;
		-webkit-background-clip: text;
		-moz-background-clip: text;
		-webkit-text-fill-color: transparent;
		-moz-text-fill-color: transparent;
	}
	@media (min-width: 768px) {
	}
	@media (max-width: 767px) {
		.templates-menu > li.active,
		.templates-menu--sub > li.active {
			-webkit-text-stroke: 0.1px;
			@apply bg-gray-300 text-gray-900;
		}
		.templates-menu .category-icon {
			width: 0.9rem;
			height: 0.9rem;
		}
		.templates-menu > li,
		.templates-menu--sub > li {
			background: none;
			font-size: 14px;
		}
		.templates-menu > li a,
		.templates-menu--sub > li a {
			padding: 0.2rem 0.4rem;
			gap: 0.3rem;
		}
		.form-templates-h1 {
			font-size: 1.75rem;
			line-height: 1.3;
		}
		.form-templates-h1.small {
			font-size: 1.6rem;
			line-height: 1.3;
		}
		.form-templates-description {
			font-size: 0.95rem;
		}
		.form-templates-description.large {
			font-size: 0.95rem;
		}
	}
</style>

<script lang="ts">
	import Navigation from "$src/lib/Components/Basic/Navigation.svelte";
	import { PUBLIC_SITE_URL } from "$env/static/public";
	import { page } from "$app/stores";
	import { onMount } from "svelte";

	export let data;

	let query = "";

	$: pageQuery = $page.data.query ?? "";
	$: updatePageQuery(pageQuery.trim());

	const updatePageQuery = (pageQuery: string) => {
		if (pageQuery !== query.trim()) {
			query = pageQuery;
		}
	};

	$: addItem = $page.data.template
		? { name: $page.data.template.forms.name, id: $page.data.template.slug }
		: null;
	$: highlight = $page.data.template?.classify?.[0]?.subcategory ?? null;

	onMount(() => {
		query = data.query ?? "";
	});
</script>

<Navigation
	width="{245}"
	highlight="{highlight}"
	addItem="{addItem}"
	hideNavOnDesktop="{Boolean(highlight)}"
	class="md:pt-10"
	label="Templates"
	path="/form-templates"
	site_base="{PUBLIC_SITE_URL}"
	items="{data.nav_items}">
	<form
		style="padding: 3px"
		slot="search"
		class="w-full relative flex flex-row items-center"
		action="/form-templates">
		<input
			class="input lg md:md w-full"
			placeholder="Search"
			name="query"
			value="{data.query}" />
		{#if query}
			<a
				class="absolute text-red-400 right-1 px-2 inline-flex items-center"
				aria-label="Reset search"
				href="/form-templates">
				×
			</a>
		{/if}
	</form>
	<slot />
</Navigation>
